import { getResolvedFileMediaType } from "~/constants/mimeType";

export const isImageType = (kind: string) => kind.startsWith("image/") && kind !== "image/svg+xml";

export const isVideoType = (kind: string) => kind.startsWith("video/");

export const isAudioType = (kind: string) => kind.startsWith("audio/");

export const isPdfType = (kind: string) => kind === "application/pdf";

export const isDocxType = (kind: string) =>
  kind === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export const isMediaType = (kind: string) =>
  isImageType(kind) || isVideoType(kind) || isAudioType(kind) || isPdfType(kind) || isDocxType(kind);

export const IMAGE_DATA_TYPE = "image/*";
const PDF_DATA_TYPE = "application/pdf";
export const IMAGE_AND_PDF_DATA_TYPES = [IMAGE_DATA_TYPE, PDF_DATA_TYPE];

export const areFileTypesAllowed = (files: File[], dataTypes: string[]) =>
  files.every((file) => {
    const mediaType = getResolvedFileMediaType(file);
    return dataTypes.some((allowedType) => {
      if (allowedType.endsWith("/*")) {
        return mediaType.startsWith(allowedType.slice(0, -1));
      }
      return mediaType === allowedType;
    });
  });
